import React from "react";
import { formatRecommendedArrival } from "../../../../utils/recommendedArrival";

const RecommendationTimeArrival = ({ time }) => {
  return (
    <div
      style={{
        display: "flex",
        marginTop: 8,
        fontSize: 12,
        color: "#434343",
      }}
    >
      <p>Rekomendasi Waktu: {formatRecommendedArrival(time)}</p>
    </div>
  );
};

export default RecommendationTimeArrival;
